import React from 'react';
import SectionIncomingConsignment from '../SectionIncomingConsignment';

const DispatchInwardConsignment = () => (
  <SectionIncomingConsignment
    sectionName="Dispatch"
    sectionDisplayName="Dispatch Section"
    backRoute="/sections/dispatch"
  />
);

export default DispatchInwardConsignment;
